import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { password });
      localStorage.setItem("ry_admin_token", r.data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch {
      toast.error("Invalid password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#FCFCFC] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-gray-200 p-10">
        <Link to="/" className="font-display text-xl tracking-tight mb-8 block">
          ROYALE <span className="text-[#9D8C70] font-light">YAAN</span>
        </Link>
        <p className="overline mb-2">Admin</p>
        <h1 className="font-display text-3xl tracking-tight font-light mb-8">Restricted access</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="pwd" className="text-xs uppercase tracking-[0.15em] text-gray-600">Password</Label>
            <Input
              id="pwd"
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              className="mt-2"
            />
          </div>
          <Button type="submit" disabled={loading || !password} data-testid="admin-login-submit" className="btn-primary rounded-sm w-full h-12">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
